// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
import React from 'react';
import { createSvgIcon } from '@mui/material/utils';
export var CaratRightIcon = createSvgIcon(/*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.70701 5.293C9.31601 4.902 8.68401 4.902 8.29301 5.293C7.90201 5.684 7.90201 6.316 8.29301 6.707L13.586 12L8.29301 17.293C7.90201 17.684 7.90201 18.316 8.29301 18.707C8.48801 18.902 8.74401 19 9.00001 19C9.25601 19 9.51201 18.902 9.70701 18.707L16.414 12L9.70701 5.293Z"
})), 'CaratRight');

//# sourceMappingURL=CaratRightIcon.js.map